import {motion} from 'framer-motion';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import {FaEnvelope,FaCheckCircle,FaExclamationTriangle,FaHome} from 'react-icons/fa';
import {useLanguage} from '../context/LanguageContext';

const Contact=()=> {
  const {t}=useLanguage();
  const [formData,setFormData]=useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [submitStatus,setSubmitStatus]=useState(null);

  const handleChange=(e)=> {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit=(e)=> {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(()=> {
      const subject=encodeURIComponent(`Contact from ${formData.name} - Cosmo Education`);
      const body=encodeURIComponent(`
Name: ${formData.name}
Email: ${formData.email}

Message:
${formData.message}
      `);
      
      window.location.href=`mailto:info@cosmopersonality.com?subject=${subject}&body=${body}`;
      
      setSubmitStatus('success');
      setFormData({name: '',email: '',message: ''});
      setIsSubmitting(false);
    },1000);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.5}}
          className="text-center mb-12"
        >
          {/* ✅ AGGIUNTO: Back to Home Button */}
          <div className="flex justify-center mb-8">
            <Link 
              to="/" 
              className="flex items-center text-green-600 hover:text-green-800 font-semibold transition-colors bg-white px-4 py-2 rounded-full shadow-md hover:shadow-lg"
            >
              <FaHome className="mr-2" />
              {t('backToHome')}
            </Link>
          </div>

          <div className="flex items-center justify-center space-x-4 mb-4">
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1750973984906-Mascotte_testa_1_to_1.png" 
              alt="Cosmo Education Logo" 
              className="h-12 w-12 rounded-full" 
            />
            <h1 className="text-4xl font-bold text-gray-900">{t('contactTitle')}</h1>
          </div>
          <p className="text-xl text-gray-600">{t('contactSubtitle')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div
            initial={{opacity: 0,x: -20}}
            animate={{opacity: 1,x: 0}}
            transition={{delay: 0.2,duration: 0.5}}
            className="bg-white rounded-lg shadow-lg p-8"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('getInTouch')}</h2>
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <FaEnvelope className="text-indigo-600 text-xl" />
                <div>
                  <h3 className="text-lg font-semibold">{t('email')}</h3>
                  <a 
                    href="mailto:info@cosmopersonality.com" 
                    className="text-indigo-600 hover:text-indigo-800 transition-colors"
                  >
                    info@cosmopersonality.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,x: 20}}
            animate={{opacity: 1,x: 0}}
            transition={{delay: 0.4,duration: 0.5}}
            className="bg-white rounded-lg shadow-lg p-8"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('sendMessage')}</h2>
            
            {submitStatus==='success' && (
              <motion.div
                initial={{opacity: 0,y: -10}}
                animate={{opacity: 1,y: 0}}
                className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center"
              >
                <FaCheckCircle className="text-green-600 mr-3" />
                <div>
                  <p className="text-green-800 font-medium">
                    {t('language')==='en' ? 'Message sent successfully!' : 'Messaggio inviato con successo!'}
                  </p>
                </div>
              </motion.div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700" htmlFor="name">
                  {t('name')} *
                </label>
                <input 
                  type="text" 
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2" 
                  placeholder={t('language')==='en' ? 'Your name' : 'Il tuo nome'}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700" htmlFor="email">
                  {t('email')} *
                </label>
                <input 
                  type="email" 
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2" 
                  placeholder={t('language')==='en' ? 'your.email@example.com' : 'tua.email@esempio.com'}
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700" htmlFor="message">
                  {t('message')} *
                </label>
                <textarea 
                  rows={4} 
                  id="message"
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2" 
                  placeholder={t('language')==='en' ? 'Your message...' : 'Il tuo messaggio...'}
                />
              </div>
              
              <button 
                type="submit" 
                disabled={isSubmitting}
                className={`w-full py-3 px-4 rounded-md font-medium transition duration-300 ${
                  isSubmitting 
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-indigo-600 hover:bg-indigo-700'
                } text-white`}
              >
                {isSubmitting 
                  ? (t('language')==='en' ? 'Sending...' : 'Invio in corso...')
                  : t('sendBtn')
                }
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;